module.exports = __webpack_public_path__ + "static/media/lady-machine.807149f4.png";